import * as Characteristics from "~/features/selectionAssistant/gearbox/components/CharacteristicsFilter/constants/CharacteristicCodes";
import { toMapFn } from "~/common/utils/reducers";
import { type FacetFilterDefinition } from "~/features/selectionAssistant/gearbox/models";

export * as Characteristics from "~/features/selectionAssistant/gearbox/components/CharacteristicsFilter/constants/CharacteristicCodes";

export const CHARACTERISTIC_CODE_LIST = Object.values(Characteristics);
export const CHARACTERISTIC_CODE_LIST_EXCEPT_TYPE = CHARACTERISTIC_CODE_LIST.filter(
  (code) => code !== Characteristics.PRODUCT_TYPE,
);

export const CHARACTERISTIC_WITH_FLANGE = Characteristics.BUILD_TYPE;
export const FLANGE_VALUE_CODE_PREFIX = "design_variant_B_";

export function selectedValuesContainFlange(selectedValue: string[] | undefined | null) {
  if (!selectedValue) {
    return false;
  }
  return selectedValue.some(valueIsFlange);
}
export function valueIsFlange(value: string | undefined | null) {
  if (!value) {
    return false;
  }
  return value.startsWith(FLANGE_VALUE_CODE_PREFIX);
}

export const FLANGE_SPECIFIC_CHARACTERISTICS = [
  Characteristics.ENGINE_CONSTRUCTION_VARIANT,
  Characteristics.INSTALLATION_POSITION,
];

export const MULTIVALUE_MAP = {
  [Characteristics.PRODUCT_TYPE]: false,
  [Characteristics.BUILD_DESIGN]: false,
  [Characteristics.BUILD_TYPE]: true,
  [Characteristics.BUILD_SIZE]: true,
  [Characteristics.GEAR_RATIO]: true,
  [Characteristics.ENGINE_CONSTRUCTION_VARIANT]: false,
  [Characteristics.INSTALLATION_POSITION]: false,
};

export const getInitialCharacteristicValue = (definition: FacetFilterDefinition) => {
  return definition.multivalued ? [] : "";
};
export const getInitialCharacteristicValues = (definitions: Record<string, FacetFilterDefinition>) => {
  return toMapFn(
    CHARACTERISTIC_CODE_LIST.map((key) => definitions[key]).filter(Boolean),
    (def) => def.code,
    getInitialCharacteristicValue,
  );
};

export const HIGH_PRECISION_CHARACTERISTIC_VALUE = "PSC";
export const STRAIN_WAVE_CHARACTERISTIC_VALUE = "RT";

export const VALID_VALUE_PREFIXES_FOR_HIGH_PRECISION: Record<(typeof CHARACTERISTIC_CODE_LIST)[0], string[]> = {
  [Characteristics.PRODUCT_TYPE]: [HIGH_PRECISION_CHARACTERISTIC_VALUE],
  [Characteristics.BUILD_DESIGN]: ["design_H_", "design_V_"],
  [Characteristics.BUILD_TYPE]: ["design_variant_E_", FLANGE_VALUE_CODE_PREFIX],
  [Characteristics.BUILD_SIZE]: [
    "size_code_030_",
    "size_code_056_",
    "size_code_057_",
    "size_code_080_",
    "size_code_112_",
    "size_code_160_",
    "size_code_224_",
    "size_code_300_",
    "size_code_400_",
    "size_code_500_",
  ],
  [Characteristics.GEAR_RATIO]: [
    "100.0",
    "120.0",
    "125.0",
    "131.5",
    "140.0",
    "150.0",
    "160.0",
    "200.0",
    "35.5",
    "45.0",
    "50.0",
    "56.0",
    "63.0",
    "71.0",
    "80.0",
    "90.0",
  ],
  [Characteristics.ENGINE_CONSTRUCTION_VARIANT]: ["engine_construction_variant_1_", "engine_construction_variant_2_"],
  [Characteristics.INSTALLATION_POSITION]: ["installation_position_V1_", "installation_position_V3_"],
};

export const VALID_VALUE_PREFIXES_FOR_STRAIN_WAVE: Record<(typeof CHARACTERISTIC_CODE_LIST)[0], string[]> = {
  [Characteristics.PRODUCT_TYPE]: [STRAIN_WAVE_CHARACTERISTIC_VALUE],
  [Characteristics.BUILD_DESIGN]: ["design_BHS_", "design_BMS_", "design_CS_", "design_UHS_", "design_UHS-T_"],
  [Characteristics.BUILD_TYPE]: ["design_variant_C_", "design_variant_H_"],
  [Characteristics.BUILD_SIZE]: ["size_code_14_", "size_code_17_", "size_code_20_", "size_code_25_", "size_code_32_"],
  [Characteristics.GEAR_RATIO]: ["100.0", "120.0", "160.0", "50.0", "80.0"],
  [Characteristics.ENGINE_CONSTRUCTION_VARIANT]: [],
  [Characteristics.INSTALLATION_POSITION]: [],
};
